import { SonarText } from './text';
import { SonarUserTooltip } from './SonarUserTooltip';
import { UserAvatar } from './avatar';
import { Space } from 'antd';
import React from 'react';
import { useCurrentUser, useUserReference } from '@hooks';
export const SonarUser = ({ avatar = true, className, large, placeholder, shape, showTooltip, userId, withFullName = true }) => {
    var _a;
    const { fullName, email } = useUserReference(userId);
    const { isGuest } = useCurrentUser();
    let avatarElement;
    let labelElement;
    if (avatar) {
        avatarElement = React.createElement(UserAvatar, { className: className, large: large, shape: shape, userId: userId });
    }
    if (withFullName || placeholder) {
        labelElement = React.createElement(SonarText, { className: 'user-label' }, fullName !== null && fullName !== void 0 ? fullName : placeholder);
    }
    const userBase = React.createElement(Space, { className: 'sonar-user', key: userId, size: 8 },
        avatarElement,
        labelElement);
    if (showTooltip && !isGuest) {
        return (React.createElement(SonarUserTooltip, { avatar: avatarElement, email: email, name: (_a = fullName !== null && fullName !== void 0 ? fullName : placeholder) !== null && _a !== void 0 ? _a : '' }, userBase));
    }
    return userBase;
};
